import React, { useState, useEffect, useRef } from 'react';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { appSubmission, AppUserList, getCustomFields, getPipelines, getReportApps, registeredUserList, UpdateLeadStage } from '../../utils/urls';
import axios from '../../utils/axios';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { Slider } from 'primereact/slider';
import { useSelector } from 'react-redux';
import AppPopup from './appsKanban/AppPopup';
import FlexComponent from '../FlexComponent';
import { Toast } from 'primereact/toast';
import AppModal from '../../shared/AppModal';
import { WorkingOnChip } from './workingOn/WorkingOn';

export default function AppsTable({ popupHeader = false, userId, countsIds = false, isHotLeads = false }) {
    const navigate = useNavigate()
    const [appLeads, setAppLeads] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isMounted, setIsMounted] = useState(false)
    const [appScoreValue, setAppScoreValue] = useState([0, 100])
    const [allAppScoreLeadsData, setAllAppScoreLeadsData] = useState(null)
    const isSuperuser = useSelector((state) => state.user.isSuperuser);

    const toast = useRef(null);
    const dt = useRef(null);

    const [pipelines, setPipelines] = useState([]);
    const [pipelineId, setPipelineId] = useState("");
    const [pipelineStages, setPipelineStages] = useState();
    const [stageIds, setStageIds] = useState("")
    const [allPipelinesData, setAllPipelinesData] = useState([])
    const [inactivePipelineId, setInactivePipelineId] = useState("")

    const [isOpen, setIsOpen] = useState(false);
    const [applicantData, setApplicantData] = useState();
    const [popupLoad, setPopupLoad] = useState(false);
    const [registeredUsersList, setRegisteredUsersList] = useState([]);
    const [loanDetailsCustomFields, setLoanDetailsCustomFields] = useState([])
    const [realEstateTransactionsCustomFields, setRealEstateTransactionsCustomFields] = useState([])
    const [allCustomFields, setAllCustomFields] = useState([])
    const loanDetailsFields = ["Onedrive Link", "Gdrive Link", "Loan File ID", "Purchase Price", "Loan Amount", "Est. Taxes", "Loan Amount Status", "Closing Date", "Subject Property Address", "Sellers Concession", "First Payment Date", "Insurance Inspection Date"]
    const realEstateTransactionFields = ["Real Estate Gdrive Link"]


    useEffect(() => {
        if (userId) {
            if (!countsIds && !isHotLeads) {
                setLoading(true)
                axios.get(`${AppUserList}?userId=${userId}`, {
                    headers: { 'Content-Type': 'application/json' },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            console.log(response.data)
                            setAppLeads(response.data);
                            setLoading(false);
                        }
                    })
                    .catch((error) => {
                        setAppLeads(null)

                    })
            } else if (isHotLeads && !countsIds) {
                setLoading(true)
                axios.get(`${AppUserList}?userId=${userId}&is_hot_lead=true`, {
                    headers: { 'Content-Type': 'application/json' },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            console.log(response.data)
                            setAppLeads(response.data);
                            setAllAppScoreLeadsData(response.data)
                            setLoading(false);
                        }
                    })
                    .catch((error) => {
                        setAppLeads(null)

                    })
            } else {
                axios.get(`${getReportApps}?app_id=${countsIds}`, {
                    headers: { 'Content-Type': 'application/json' },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            console.log(response.data)
                            setAppLeads(response.data);
                            setLoading(false);
                        }
                    })
                    .catch((error) => {
                        setAppLeads(null)

                    })
            }
        }
        getAllPipelines()
    }, [AppUserList, isMounted, userId, countsIds, isHotLeads])

    useEffect(() => {
        let start = appScoreValue[0]
        let end = appScoreValue[1]
        if (allAppScoreLeadsData?.length) {
            let updatedData = allAppScoreLeadsData
            updatedData = updatedData.filter(item =>
                item.app_score >= start && item.app_score <= end
            );
            setAppLeads(updatedData)
        }

    }, [appScoreValue])

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        full_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        email: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        phone: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        location_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        app_application_by: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        app_status: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        language: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    });

    const srNoBodyTemplate = (rowData, props) => {
        const rowIndex = props.rowIndex + 1;
        return <div className='status'>{rowIndex}</div>;
    };


    const onGlobalFilterChange = (event) => {
        const value = event.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
    };

    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({ selectionOnly });
    };

    const renderHeader = () => {
        const value = filters['global'] ? filters['global'].value : '';

        return (
            <div className={`${"header-container-with-csv-export"} ${isHotLeads ? "isHotLeads" : ""}`}>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" value={value || ''} onChange={(e) => onGlobalFilterChange(e)} placeholder="Global Search" />
                </span>
                <div style={{display : isHotLeads ? "flex" : "", width: isHotLeads ? "100%" : ""}} >
                {isHotLeads && <div style={{width: "100%"}} className="flex align-items-center justify-content-end gap-2 apps-score-range">
                    <p style={{ color: "white" }} >App Score Range - {appScoreValue[0] || '0'} to {appScoreValue[1]}</p>
                    <div className="apps-slider-wrap" style={{ padding: "10px 0", borderRadius: "5px" }} >
                        <Slider min={0} max={100} value={appScoreValue} onChange={(e) => setAppScoreValue(e.value)} range />
                    </div>
                </div>}
                {isSuperuser && <div className="flex align-items-center justify-content-end gap-2">
                    <Button type="button" icon="pi pi-file" rounded onClick={() => exportCSV(false)} data-pr-tooltip="CSV" />
                </div>}
                </div>
            </div>

        );
    };

    const getAllPipelines = () => {
        if (userId) {
            const url = `${getPipelines}?userId=${userId}`;
            axios.get(url, {
                headers: { 'Content-Type': 'application/json' }
            })
                .then((response) => {
                    if (response.status === 200) {
                        setAllPipelinesData(response?.data)
                        const options = response?.data?.filter((pipeline) => {
                            if (pipeline.name === "Inactive Apps") {
                                setInactivePipelineId(pipeline.id)
                                return false;
                            }
                            return true;
                        })?.map((pipeline) => ({
                            label: pipeline.name,
                            value: pipeline.id,
                        })) || [];
                        setPipelines(options);
                        const stages = response.data
                        const item = stages?.find(item => item.id == 1);
                        setPipelineStages(item.stages)
                    }
                })
                .catch((error) => {
                    // Handle error
                });
        }
    };

    const profileView = (rowData) => {
        const contact_id = rowData.ghl_contact_id
        const form_id = rowData.form_id
        return <Button className='view-button' label="View Profile" onClick={() => redirectProfilePage(contact_id, form_id)} />
    };

    const cardView = (rowData) => {
        const contact_id = rowData.ghl_contact_id
        const form_id = rowData.form_id
        return <Button className='view-button' label="View App" onClick={() => openPopupFn(form_id, 1)} />
    };

    const redirectProfilePage = (contact_id, form_id) => {
        // navigate(`/app/${contact_id}/${form_id}`)
        window.open(`/app/${contact_id}/${form_id}`, '_blank')
    }

    const emptyBody = (field) => (rowData) => rowData[field] != null && rowData[field] !== '' ? rowData[field] : '_';

    const datesBody = (rowData) => {
        let dateToShow = ""
        if (popupHeader === "Total Docs In") dateToShow = rowData.doc_in_date;
        if (popupHeader === "Total PreApps") dateToShow = rowData.preapp_date;
        if (popupHeader === "Total Shoppers") dateToShow = rowData.shopper_date;
        return <div>{dateToShow}</div>
    };

    const getDatesHeader = () => {
        if (popupHeader === "Total Docs In") return "Doc In Date";
        if (popupHeader === "Total PreApps") return "Pre-App Date";
        if (popupHeader === "Total Shoppers") return "Shopper Date";
        return "Date";
    };

    const handleStageUpdate = (contact_id, form_id, stage, prevStage, emails, isLoad = false, stageId = "") => {
        // console.log(stage, prevStage)
        const data = {
            // stage: stage,
            userId: userId,
            stage_id: stageId ? stageId : stageIds[stage],
            email_list: emails
        }
        console.log("datttttttttt", data);

        const stageUrl = `${UpdateLeadStage}${contact_id}/${form_id}`
        axios.post(stageUrl, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Successfully Updated', life: 3000 });
                    const url = `${appSubmission}${form_id}?pipelineId=${pipelineId}`
                    axios.get(url, {
                        headers: { 'Content-Type': 'application/json' }
                    })
                        .then((response) => {
                            if (response.status === 200) {
                            }
                        })

                }
                else if (response.status === 208) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: response.data, life: 3000 });
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            })
    }

    const handleClose = () => {
        setIsOpen(false);
    };

    const getAllCustomFields = () => {
        const listUrl = `${getCustomFields}`;
        axios.get(listUrl, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    // setAllCustomFields(response.data);
                    let loanDetailsData = response.data.filter(data => loanDetailsFields.includes(data.title))
                    let realEstateTransactionsData = response.data.filter(data => realEstateTransactionFields.includes(data.title))
                    let restCustomFieldsData = response.data.filter(data => !loanDetailsFields.includes(data.title) && !realEstateTransactionFields.includes(data.title))
                    setLoanDetailsCustomFields(loanDetailsData)
                    setRealEstateTransactionsCustomFields(realEstateTransactionsData)
                    setAllCustomFields(restCustomFieldsData)
                }
            })
            .catch((error) => {
                // Handle error
            });
    };

    const openPopupFn = (formId, pipelineId = 1) => {
        setPipelineId(pipelineId);
        setIsOpen(true);
        setPopupLoad(true);
        getAllCustomFields();
        const url = `${appSubmission}${formId}?pipelineId=1`;
        axios.get(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    const data = response.data;
                    setApplicantData(data);
                    setPopupLoad(false);
                }
            })
            .catch((error) => {
                // Handle error
            });

        const registeredUsersUrl = `${registeredUserList}`;
        axios.get(registeredUsersUrl, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    const options = response?.data?.map((user) => ({
                        label: user.name,
                        value: user.user_id,
                        image: user.image
                    })) || [];
                    setRegisteredUsersList(options);
                }
            })
            .catch((error) => {
                // Handle error
            });
    };

    function parseDateFlexible(dateStr) {
        if (!dateStr) return null;

        // Try to parse common American formats with AM/PM
        const dt = new Date(dateStr);
        if (!isNaN(dt.getTime())) return dt;

        // Fallback: replace space before AM/PM → make it more standard
        let cleaned = dateStr.replace(/(\d{1,2}:\d{2}:\d{2})\s+(AM|PM)/i, '$1$2');
        const fallback = new Date(cleaned);
        if (!isNaN(fallback.getTime())) return fallback;

        return null; // or keep as string if parsing fails
    }

    const header = renderHeader();

    return (
        <div className="card p-fluid">
            <Toast ref={toast} />
            <DataTable className="oba-datatable" size='small' ref={dt} value={appLeads} paginator rows={15} rowsPerPageOptions={[15, 30, 50, 100]} paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" scrollable scrollHeight="60vh" header={header} filters={filters} loading={loading} onFilter={(e) => setFilters(e.filters)} dataKey="ghl_contact_id"
                stateStorage="session" stateKey="dt-apps-table" tableStyle={{ minWidth: '50rem' }}>
                <Column field="full_name" header="Name" frozen style={{ minWidth: 180 }} sortable body={(rowData, options) => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ fontSize: '11px', color: '#7a7a84', flexShrink: 0 }}>#{options.rowIndex + 1}</span>
                        <span>{rowData.full_name}</span>
                        <WorkingOnChip app={rowData} />
                    </div>
                )}></Column>
                {(popupHeader && (popupHeader === "Total Docs In" || popupHeader === "Total Credit Pulled" || popupHeader === "Total PreApps" || popupHeader === "Total Shoppers" ||
                    popupHeader === "Total Open Deals" || popupHeader === "Total Closed Deals" || popupHeader === "Total Pending Closings" || popupHeader === "Total Projected Closings")) && <Column field="loan_file_id" header="Loan File Id" style={{ minWidth: '10rem' }} sortable body={emptyBody('loan_file_id')}></Column>}
                {(popupHeader && (popupHeader === "Total Replies")) && <Column field="email" header="Email" style={{ minWidth: '2rem' }} sortable body={emptyBody('email')}></Column>}
                {(popupHeader && (popupHeader === "Total Replies")) && <Column field="phone" header="Phone" style={{ minWidth: '2rem' }} sortable body={emptyBody('phone')}></Column>}
                {/* <Column field="location_name" header="Location" style={{ minWidth: '13rem' }} sortable ></Column> */}
                {((popupHeader !== "Total Pending Closings" && popupHeader !== "Total Projected Closings")) && <Column field="location_name" header="Location" style={{ minWidth: '10rem' }} sortable body={emptyBody('location_name')}></Column>}
                {(popupHeader && (popupHeader === "Total Replies")) && <Column field="language" header="Language" style={{ minWidth: '2rem' }} sortable body={emptyBody('language')}></Column>}
                <Column field="app_application_by" header="Application By" style={{ minWidth: '11rem' }} sortable body={emptyBody('app_application_by')}></Column>
                {isHotLeads && <Column field="app_score" header="App Score" style={{ minWidth: '9rem' }} sortable body={emptyBody('app_score')}></Column>}
                <Column field="app_status" header="Status" style={{ minWidth: '13rem' }} sortable body={emptyBody('app_status')}></Column>
                <Column field="client_status" header="Client Status" style={{ minWidth: '13rem' }} sortable body={emptyBody('client_status')}></Column>
                {(popupHeader && (popupHeader === "Total Docs In" || popupHeader === "Total Credit Pulled" || popupHeader === "Total PreApps" || popupHeader === "Total Shoppers" ||
                    popupHeader === "Total Open Deals" || popupHeader === "Total Closed Deals" || popupHeader === "Total Pending Closings" || popupHeader === "Total Projected Closings")) && <Column field="loan_amount" header="Loan Amount" style={{ minWidth: '10rem' }} sortable body={emptyBody('loan_amount')}></Column>}
                <Column field="income" header="Income" style={{ minWidth: '1rem' }} sortable body={emptyBody('income')}></Column>
                <Column field="credit" header="Credit" style={{ minWidth: '1rem' }} sortable body={emptyBody('credit')}></Column>
                <Column field="savings" header="Savings" style={{ minWidth: '1rem' }} sortable body={emptyBody('savings')}></Column>
                {(popupHeader && (popupHeader === "Total Docs In" || popupHeader === "Total PreApps" || popupHeader === "Total Shoppers")) && <Column header={getDatesHeader()} body={datesBody} style={{ minWidth: '10rem' }} sortable></Column>}
                {(popupHeader && (popupHeader === "Total Pending Closings" || popupHeader === "Total Projected Closings")) && <Column field="closing_date" header="Closing Date" style={{ minWidth: '10rem' }} sortable body={emptyBody('closing_date')}></Column>}
                {(popupHeader && (popupHeader === "Total Open Deals" || popupHeader === "Total Pending Closings" || popupHeader === "Total Projected Closings")) && <Column field="open_date" header="Open Date" style={{ minWidth: '10rem' }} sortable body={emptyBody('open_date')}></Column>}
                {(popupHeader && (popupHeader === "Total Closed Deals")) && <Column field="closed_date" header="Closed Date" style={{ minWidth: '10rem' }} sortable body={emptyBody('closed_date')}></Column>}
                {/* <Column field="created_date" header="Date" style={{ minWidth: '10rem' }} sortable></Column> */}
                <Column field="created_date" header="Date" sortable style={{ minWidth: '10rem' }} 
                    sortFunction={({ data, field, order }) => {
                        return data.sort((a, b) => {
                            const dateA = parseDateFlexible(a[field]);
                            const dateB = parseDateFlexible(b[field]);
                            if (!dateA) return order === 1 ? -1 : 1;
                            if (!dateB) return order === 1 ? 1 : -1;
                            return order * (dateA - dateB);
                        });
                    }}
                />
                <Column body={cardView} style={{ minWidth: '10rem' }}></Column>
                <Column body={profileView} style={{ minWidth: '10rem' }}></Column>
            </DataTable>

            <AppModal visible={isOpen} onHide={handleClose}>
                <div style={{ marginTop: '1rem', minHeight: "70vh" }}>
                    {!popupLoad ? (
                        <AppPopup
                            isFromTable={true}
                            applicantData={applicantData}
                            pipelineId={pipelineId}
                            id={applicantData?.app_status}
                            pipelineStages={pipelineStages}
                            allPipelinesData={allPipelinesData}
                            isFromSearch={true}
                            allCustomFields={allCustomFields}
                            loanDetailsCustomFields={loanDetailsCustomFields}
                            realEstateTransactionsCustomFields={realEstateTransactionsCustomFields}
                            // setBoardSections={setBoardSections}
                            setApplicantData={setApplicantData}
                            isFromOtherPages={true}
                            handleStageUpdate={handleStageUpdate}
                            usersList={registeredUsersList}
                            userId={userId}
                            handleClose={handleClose}
                            toast={toast}
                        />
                    ) : (
                        <FlexComponent flexDirection="column" justifyContent="center">
                            <div style={{ minWidth: "40vw", height: "100%" }} className='loadingAppItem'></div>
                        </FlexComponent>
                    )}
                </div>
            </AppModal>
        </div>
    );
}